<template>
  <div v-if="loadingStock">
    <SpringSpinner color="blue" :size="12" :animation-duration="500"/>
  </div>
  <div v-else class="producto__stock">
    <small class="font-weight-bold" v-if="stockProducto.length === 0"> Cargando Stock </small>
    <ul v-else>
      <li v-for="stock in stockProducto">{{setNombreSucursal(stock.sucursal_id)}}: {{ stock.stock }}</li>
    </ul>
  </div>
</template>

<script>
  import SpringSpinner from "epic-spinners/src/components/lib/SpringSpinner";

  export default {
    name: "Stock",
    components: {SpringSpinner},
    props: {
      stockProducto: {
        type: Array,
        default: () => []
      },
      loadingStock: false
    },
    methods: {
      setNombreSucursal(id) {
        return this.$store.getters.sucursal(id).nombre
      }
    }
  }
</script>

<style scoped lang="scss">
  .producto__stock {
    animation: fadeIn linear 200ms;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    width: 100%;
    font-size: 11px;
    font-weight: bold;

    li {
      width: 100%;
    }
  }

  @keyframes fadeIn {
    to{
      opacity: 1;
    }
    from{
      opacity: 0;
    }
  }
</style>
